import { render, staticRenderFns } from "./TaxabilityTable.vue?vue&type=template&id=aef400fc&scoped=true&"
import script from "./TaxabilityTable.vue?vue&type=script&lang=ts&"
export * from "./TaxabilityTable.vue?vue&type=script&lang=ts&"
import style0 from "./TaxabilityTable.vue?vue&type=style&index=0&id=aef400fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef400fc",
  null
  
)

export default component.exports